import Toolbar from './src/Toolbar'

export default Toolbar
